import dynamic from 'next/dynamic'

export const Affiliate = dynamic(
  () => import('components/organisms/affiliate').then((mod) => mod.Affiliate),
  {
    ssr: false,
  },
)
export const EmbededCommunity = dynamic(
  () =>
    import('components/organisms/embededCommunity').then(
      (mod) => mod.EmbededCommunity,
    ),
  {
    ssr: false,
  },
)
// export const BMICard = dynamic(
//   () =>
//     import('components/organisms/embededHeathToolCards/bmi').then(
//       (mod) => mod.BMICard,
//     ),
//   {
//     ssr: false,
//   },
// )
// export const BMRCard = dynamic(
//   () =>
//     import('components/organisms/embededHeathToolCards/bmr').then(
//       (mod) => mod.BMRCard,
//     ),
//   {
//     ssr: false,
//   },
// )
export const DueDateCalculator = dynamic(
  () =>
    import('components/templates/DueDateEmbed').then(
      (mod) => mod.DueDateCalculator,
    ),

  {
    ssr: false,
  },
)
export const CalculatorForm = dynamic(
  () => import('container/ovulation/components/CalculatorForm'),

  {
    ssr: false,
  },
)
export const InjectedRelatedPosts = dynamic(
  () =>
    import('components/organisms/relatedPosts/injectedRelatedPosts').then(
      (mod) => mod.InjectedRelatedPosts,
    ),

  {
    ssr: false,
  },
)
export const BabyGrowthCard = dynamic(
  () =>
    import('components/organisms/embededHeathToolCardsV2/embedBabyGrowth').then(
      (mod) => mod.BabyGrowthCard,
    ),
  {
    ssr: false,
  },
)
export const DueDateCardEmbeded = dynamic(
  () =>
    import('components/organisms/embededHeathToolCardsV2/embedDueDate').then(
      (mod) => mod.DueDateCardEmbeded,
    ),
  {
    ssr: false,
  },
)
export const OvulationCardEmbeded = dynamic(
  () =>
    import('components/organisms/embededHeathToolCardsV2/embedOvulation').then(
      (mod) => mod.OvulationCardEmbeded,
    ),
  {
    ssr: false,
  },
)
export const EmbeddedCommunity = dynamic(
  () =>
    import('components/organisms/embeddedCommunity').then(
      (mod) => mod.EmbeddedCommunity,
    ),
  {
    ssr: false,
  },
)
export const PWGEmbedded = dynamic(
  () =>
    import('components/organisms/embededHeathToolCardsV2/embedPwg').then(
      (mod) => mod.PWGEmbedded,
    ),
  {
    ssr: false,
  },
)
export const BabyPoopCard = dynamic(() =>
  import('components/organisms/embededHeathToolCardsV2/baby-poop').then(
    (mod) => mod.BabyPoopCard,
  ),
)
export const BabyVaccinationEmbed = dynamic(() =>
  import(
    'components/organisms/embededHeathToolCardsV2/embedBabyVaccination'
  ).then((mod) => mod.BabyVaccination),
)
